import React from "react";
import { useSelector } from "react-redux";
import { injectIntl, intlShape } from "@edx/frontend-platform/i18n";
import { Link } from "react-router-dom";
import { getConfig } from "@edx/frontend-platform";

import { useModel } from "../../generic/model-store";
import useIsSpeechcraftMFE from "../../hooks/useIsSpeechcraftMFE";
import { getDashboardPlatformURL } from "../../utils/utility";
import messages from './messages.js';
import {Role} from "../../config";

function CoordinatorTrackingTab({ intl }) {
  const { courseId } = useSelector((state) => state.courseHome);
  const coordinatorTrackingData = useModel("coordinatorTracking", courseId);
  const rolesData = useSelector((state) => state.app.roles);
  const isSpeechcraftMFE = useIsSpeechcraftMFE();

  const isSpeechcrafter =
    isSpeechcraftMFE &&
    !!rolesData?.[0]?.roles?.find((role) => role.position_code === Role.speechcrafter);

  React.useEffect(() => {
    if (!isSpeechcrafter) {
      window.location.assign(getDashboardPlatformURL());
    }
  }, [isSpeechcrafter, rolesData]);

  return (
    <div className="container">
      <div className="row">
        <div className="main-content-wrapper w-100">
          <div className="position-relative breadcrumbs-wrapper pb-2">
            <nav aria-label="breadcrumb" className="mt-4 d-inline-block">
              <ol className="list-unstyled d-flex flex-wrap flex-lg-nowrap align-items-center m-0">
                <li>
                  <Link
                    className="flex-shrink-0"
                    to={`#`}
                    onClick={() =>
                      window.location.assign(getDashboardPlatformURL())
                    }
                  >
                    {intl.formatMessage(messages.homeBreadCrumb)}
                  </Link>
                </li>
                <li>
                  <span>/</span>
                </li>
                <li>
                  <a className="flex-shrink-0 color-dark-grey" href="#">
                    {intl.formatMessage(messages.trackingBreadCrumb)}
                  </a>
                </li>
              </ol>
            </nav>
          </div>

          <div className="coordinator-tracking">
            <h2>{intl.formatMessage(messages.coordinatorTrackingHeading)}</h2>
            <h3>{intl.formatMessage(messages.coordinatorTrackingOverview)}</h3>
            {!coordinatorTrackingData?.results?.length || !isSpeechcrafter ? (
              <div className="d-flex flex-wrap justify-content-center">
                {intl.formatMessage(messages.noRecord)}
              </div>
            ) : (
              coordinatorTrackingData?.results.map(
                ({ status, name, comments, description }) => (
                  <div className="tracking-row">
                    <div className="tracking-col1">
                      <h4>{name}</h4>
                    </div>
                    <div className="tracking-col2">
                      <span className="th-chip">{status}</span>
                      <p>{description}</p>
                      {(comments.groupComment || comments.individualComment) &&
                        status === "Completed" && (
                          <>
                            <h4>{intl.formatMessage(messages.commentsHeading)}</h4>
                            {comments.groupComment && (
                              <p>{comments.groupComment}</p>
                            )}
                            {comments.individualComment && (
                              <p>{comments.individualComment}</p>
                            )}
                          </>
                        )}
                    </div>
                  </div>
                )
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

CoordinatorTrackingTab.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(CoordinatorTrackingTab);
